<template>
    <svg
        height="24px"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
        style="fill: currentColor"
    >
        <!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.!-->
        <path
            d="M310.7 413.8c-1.3-6.6-7.8-10.9-14.4-9.4-10.7 2.4-27.4 5.4-45.4 5.4-56.8 0-101.9-34.8-121.5-85.4h113.7a12 12 0 0 0 11.7-9.4l6.4-28.4c1.7-7.5-4-14.6-11.7-14.6H115.2c-1.2-14.3-1.4-28.3 .1-42.2H262a12 12 0 0 0 11.7-9.4l6.5-29.8c1.6-7.5-4.1-14.6-11.7-14.6H130.2c20.6-45 62.7-75 117.6-75 14.5 0 28.6 2.3 37.9 4.1 6.2 1.3 12.3-2.5 14-8.6l12-44.4c1.8-6.7-2.5-13.6-9.3-14.9C290.2 34.9 270.7 32 249.6 32 152.5 32 74 92.3 45.1 176H12c-6.6 0-12 5.4-12 12v29.8c0 6.6 5.4 12 12 12h21.6c-1 13.6-1.2 29.3-.2 42.2H12c-6.6 0-12 5.4-12 12v28.4c0 6.6 5.4 12 12 12h30.1C67.1 414.7 145.3 480 249.6 480c26.3 0 48.6-4.5 61.1-7.8 6.2-1.6 10-7.7 8.8-14l-8.8-44.5z"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "fa-euro-sign",
});
</script>
